// extracted by mini-css-extract-plugin
export default {"tooltip":"vp-z","sharingV2":"wp-z","sharingIconsV2":"xp-z","links":"yp-z","link":"zp-z","facebookV2":"Ap-z","twitterV2":"Bp-z","pinterestV2":"Cp-z"};